import { useEffect, useState } from "react";
import { http } from "../../lib/api";
import PremiumLayout from "./PremiumLayout";

const STUDIO_IMG = "https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=1600&auto=format&fit=crop&q=80";

export default function PremiumAbout() {
  const [team, setTeam] = useState([]);
  useEffect(() => {
    http.get("/marketing/site").then(({ data }) => setTeam(data.team || [])).catch(() => {});
  }, []);
  return (
    <PremiumLayout>
      <section className="max-w-[1400px] mx-auto px-6 md:px-10 pt-16 pb-8">
        <div className="mono gold">About the studio</div>
        <h1 className="serif text-5xl md:text-7xl leading-[1.02] mt-4 cream">
          A ten-year practice, <span className="gold italic">quiet by design.</span>
        </h1>
      </section>

      {/* Editorial intro */}
      <section className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 grid md:grid-cols-5 gap-10 items-start">
        <div className="md:col-span-3 relative aspect-[4/3] overflow-hidden border border-[#1F1F1F]">
          <img src={STUDIO_IMG} alt="Studio" className="absolute inset-0 w-full h-full object-cover ken-burns" />
        </div>
        <div className="md:col-span-2">
          <div className="mono gold">Philosophy</div>
          <p className="serif text-2xl md:text-3xl leading-[1.35] cream mt-4">
            Buildings should feel like they were always there.
          </p>
          <p className="text-[#B8B0A0] mt-6 leading-relaxed">
            Dream Home Planners was founded in 2014 by a small group of architects and civil engineers who
            believed the discipline of construction and the poetry of interior design shouldn&apos;t live in
            separate rooms. Ten years later we&apos;re a studio of eighteen — running civil, interior and turnkey
            projects out of one Bengaluru studio.
          </p>
          <p className="text-[#B8B0A0] mt-4 leading-relaxed">
            Our clients aren&apos;t sold a &ldquo;look&rdquo; — they&apos;re walked through material samples, structural drawings,
            budget lines and construction sequences. Every project starts with a conversation and ends with
            a walk-through of every switch, tile, joint and finish.
          </p>
        </div>
      </section>

      {/* Team */}
      {team.length > 0 && (
        <section className="border-t border-[#1F1F1F]">
          <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20">
            <div className="mono gold">The studio</div>
            <h2 className="serif text-4xl md:text-6xl cream mt-4">Who you&apos;ll actually meet.</h2>
            <div className="mt-12 grid sm:grid-cols-2 md:grid-cols-4 gap-6">
              {team.map((m) => (
                <div key={m.name} className="group border border-[#1F1F1F] overflow-hidden">
                  <div className="relative aspect-[3/4] overflow-hidden">
                    {m.photo_url ? (
                      <img src={m.photo_url} alt={m.name}
                           className="absolute inset-0 w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500 group-hover:scale-105" />
                    ) : (
                      <div className="absolute inset-0 bg-[#1A1A1A] flex items-center justify-center serif text-6xl gold">
                        {m.name?.[0]}
                      </div>
                    )}
                  </div>
                  <div className="p-5">
                    <div className="text-xl cream">{m.name}</div>
                    <div className="gold text-[11px] tracking-[.16em] uppercase mt-2" data-testid={`team-designation-${m.name}`}>
                      {m.role || m.designation || "Team member"}
                    </div>
                    {m.bio && <div className="text-sm text-[#9A9284] mt-3">{m.bio}</div>}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}
    </PremiumLayout>
  );
}
